const removeUndefined = (obj: any) => {
  // sauce: https://stackoverflow.com/questions/25421233/javascript-removing-undefined-fields-from-an-object
  Object.keys(obj).forEach((key) => obj[key] === undefined && delete obj[key]);
};

export const obju = {
  removeUndefined,
};
